import {PersonService} from "./service/api/person.service";
import {PersonRelationPersonService} from "./service/api/person-relation-person.service";
import {HouseholdService} from "./service/api/household.service";
import {ENTITY_SERVICE_REGISTRY} from "../../core/shared/dto/dto-service/entity-service-registry";
import {ObjectHouseholdComponent} from "./component/protected-components/object-household/object-household.component";
import {PmPersonComponent} from "./component/protected-components/pm-person-component/pm-person.component";

export const PM_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['pm.Person', {route: '/pm/persons', service: PersonService, objectComponent: [{component: PmPersonComponent}]}],
            ['pm.PersonType', {route: '/pm/personTypes'}],
            ['pm.PersonDetail', {route: '/pm/personDetails'}],
            ['pm.PersonContact', {route: '/pm/personContacts'}],
            ['pm.PersonAddress', {route: '/pm/personAddresss'}],
            ['pm.Profession', {route: '/pm/professions'}],
            ['pm.ProfessionType', {route: '/pm/professionTypes'}],
            ['pm.HighestDegree', {route: '/pm/highestDegrees'}],
            ['pm.Industry', {route: '/pm/industrys'}],
            ['pm.EmploymentStatus', {route: '/pm/employmentStatuss'}],
            ['pm.PersonRelationTypeReverse', {route: '/pm/personRelationTypeReverses'}],
            ['pm.PersonRelationPerson', {route: '/pm/personRelationPersons', service: PersonRelationPersonService}],
            ['pm.PersonRelationType', {route: '/pm/personRelationTypes'}],
            ['pm.HouseholdPerson', {route: '/pm/householdPersons'}],
            ['pm.Household', {route: '/pm/households', service: HouseholdService, objectComponent: [{component: ObjectHouseholdComponent}]}],
            ['pm.Nationality', {route: '/pm/nationalitys'}],
        ],
        multi: true
    }
];
